import { render, staticRenderFns } from "./MapPeripheral.vue?vue&type=template&id=81c42cea&scoped=true&"
import script from "./MapPeripheral.vue?vue&type=script&lang=js&"
export * from "./MapPeripheral.vue?vue&type=script&lang=js&"
import style0 from "./MapPeripheral.vue?vue&type=style&index=0&id=81c42cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c42cea",
  null
  
)

export default component.exports